'use client';

import type { Event_Entry } from '@/types/graphql';
import dynamic from 'next/dynamic';

// We need to use dynamic import to avoid hydration errors
// Dynamically import the component with SSR disabled
const ShowDateTimeInner = dynamic(() => import('./ShowDateTimeInner'), { ssr: false });

interface ShowDateTimeProps {
    event: Event_Entry;
    locale: string;
}

export default function ShowDateTime(props: ShowDateTimeProps) {
    // Pass all props to the inner component
    return <ShowDateTimeInner {...props} />;
}
